import React from 'react';
import {Platform, View} from 'react-native';
import Config from 'react-native-config';

import KeyboardFocusable from '/component/base/ExtKeyboard/KeyboardFocusable';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import {ProfilePage} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {openURL} from '/util/linking.util';
import testProperties from '/util/testing/testProperties';
import {showToast} from '/util/toast.util';

import {styles} from './ContactSupport.style';

export const ContactSupport = () => {
  const {tt} = useTranslation('screen.profile.feedback.contactSupport');

  if (Platform.OS === 'web') {
    return null;
  }

  const onPress = () => {
    const onSendSMSMessage = async (phoneNumber: any) => {
      const res = await openURL('sms', phoneNumber);
      if (!res) {
        // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
        showToast('Something went wrong');
      }
    };
    const phone = Config.SFMC_PHONE_NUMBER;
    onSendSMSMessage(phone);
  };

  return (
    <View style={styles.base} {...testProperties(ProfilePage.messageUs, true)}>
      <View style={styles.iconContainer} accessible={false}>
        <Icon name="message" style={styles.icon} />
      </View>
      <View style={styles.textContainer} accessible={false}>
        <View
          accessible={true}
          accessibilityRole="header"
          accessibilityLabel="Message us">
          <Text
            variant="heading"
            allowFontScaling
            maxFontSizeMultiplier={2}
            accessible={true}
            accessibilityRole="header"
            {...testProperties(ProfilePage.messageUsHeader)}>
            {tt('title', 'Message us')}
          </Text>
        </View>
        <KeyboardFocusable
          onPress={onPress}
          accessible={true}
          accessibilityLabel="Message us. Get quick answers using the Messages app. 
    You will be navigating away from an OPTAVIA digital property and our Cookies 
    and Privacy Policy will not apply.">
          <Text
            {...testProperties(ProfilePage.messageUsDescription)}
            accessible={true}
            variant="body"
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.description}>
            {tt('description', 'Get quick answers using the Messages app')}
          </Text>
          <Text
            {...testProperties(ProfilePage.messageUsSecondDescription)}
            variant="caption"
            allowFontScaling
            maxFontSizeMultiplier={2}
            accessible={true}>
            {tt(
              'secondDescription',
              'You will be navigating away from a OPTAVIA digital property and our Cookies and Privacy Policy will not apply.',
            )}
          </Text>
        </KeyboardFocusable>
      </View>
      <Icon name="chevron-right" style={styles.rightIcon} accessible={false} />
    </View>
  );
};
